import { Button, Header } from 'components';
import { useNavigate } from 'react-router-dom';
import { useCommunity } from "components/CommunityContext";

const Success = (): JSX.Element => {
  const navigate = useNavigate();
  const { assets: { quoteAuthorImage }, texts: { successPage } } = useCommunity();
  return (
    <div>
      <Header withBackArrow={false}></Header>
      <div className="page">
        <div className="success-page">
          <div className="success-page__info-container quote-wrap">
            <span className="title-regular">{successPage?.welcomeMessage}</span>
            <br />
            <br />
            <span className="title-regular">
            {successPage?.description}
            </span>
            <div className="author-wrap">
              {quoteAuthorImage && <img className="author-image" src={quoteAuthorImage} alt="author_avatar" />}
              <div className="author-details">
                <span className="title-regular name">{successPage?.author?.name}</span>
                <span className="position body-thin">{successPage?.author?.position}</span>
              </div>
            </div>
          </div>
        </div>
        <div  className="form-container success-button">
          <Button text={successPage?.continueButton} type="button" onClick={() => navigate('/welcome')} />
        </div>
      </div>
    </div>
  );
};

export default Success;
